import React, { useRef } from 'react';
import styled from 'styled-components';
import { colorText } from '@/utils/palette';
import { PaperclipIcon } from '@/shared/dynamicImports';
import { Button } from '@/shared/components/Button';
import { colorAccent, colorAdditional } from '@/utils/palette';

export const MultipleFilesInputField = ({ onChange, name, value = [], label, error, helperText, useIcon = false }) => {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    e.preventDefault();
    const selectedFiles = Array.from(e.target.files);
    onChange(selectedFiles);
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  return (
    <>
      {label && <Label error={error}>{label}</Label>}
      <>
        {useIcon ? (
          <Button
            variant='primary'
            type='button'
            onClick={handleButtonClick}
          >
            <PaperclipIcon />
          </Button>
        ) : (
          <Button
            variant='primary'
            type='button'
            onClick={handleButtonClick}
          >
            Choose files
          </Button>
        )}
        <input
          type='file'
          name={name}
          id={name}
          onChange={handleChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
          multiple
        />
      </>
      {helperText && <HelperText>{helperText}</HelperText>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

export default MultipleFilesInputField;

export const AttachedFiles = ({ files, setFiles }) => {
  return (
    <Attachments>
      <p>Attached Files:</p>
      <div>
        {files?.map((file) => (
          <FileItem key={file?.name}>
            <span>{file?.name}</span>
            <DeleteButton
              onClick={() => setFiles((prev) => prev.filter((f) => f.name !== file.name))}
              type='button'
            >
              ×
            </DeleteButton>
          </FileItem>
        ))}
      </div>
    </Attachments>
  );
};

// region STYLES
const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const Attachments = styled.div`
  font-size: 12px;
  line-height: 1.33;
`;

const FileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: ${colorAccent};
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;
  line-height: 1;

  &:hover {
    color: ${colorAdditional};
  }
`;
// endregion
